import { Component, Input, OnInit } from '@angular/core';
import { SafePipe } from '../../../theme/pipes/safe.pipe';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'calsoft-youtube-video',
  imports: [SafePipe],
  templateUrl: './youtube-video.component.html',
  styleUrl: './youtube-video.component.scss'
})
export class YoutubeVideoComponent implements OnInit {

  autoplay:any;

  @Input() img: any;

  public youtubeUrl = environment.youtubeUrl;
  url: any;

  ngOnInit() {
    
    this.url=this.youtubeUrl+this.img.img +'?autoplay='+this.img.autoplay    
  }

}
